import { create } from 'zustand'

interface MobileMenuState {
  open: boolean
  openMenu: () => void
  closeMenu: () => void
  toggle: () => void
}

export const useMobileMenuStore = create<MobileMenuState>((set, get) => ({
  open: false,
  openMenu: () => set({ open: true }),
  closeMenu: () => set({ open: false }),
  toggle: () => set({ open: !get().open }),
}))
